import React from 'react';
import ReactDOM from 'react-dom/client';
// CRA kann Bare-Specifier (@sectepe/ui) ohne Eject/CRACO nicht auf lokale
// Pfade aliasen — daher RELATIVER Import des gespiegelten Pakets (siehe
// scripts/sync-ui.mjs). Design-System-CSS (--sec-* Tokens + .sec-* Klassen),
// das @sectepe/ui benoetigt.
import { ToastProvider, Toaster } from './sectepe-ui/index';
import './design-system/index.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ToastProvider>
      <App />
      <Toaster dismissLabel="Schliessen" />
    </ToastProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
